import { createShiftJsonClient } from '../http/shift-json-client';
import type { ShiftAuthUser, ShiftLoginResponse } from '../../models/auth.types';
import type { ShiftLoginInput } from 'shared-models';

export { ShiftAuthRequestError } from '../http/shift-request-error';
const requestJson = createShiftJsonClient(
  'אין תקשורת לשרת ההתחברות. ודאו שה-backend רץ על http://localhost:5000.',
);

const requestNoContent = async (path: string, init?: RequestInit): Promise<void> => {
  await requestJson<unknown>(path, init);
};

class ShiftAuthService {
  async login(tenantId: string, username: string, password: string): Promise<ShiftLoginResponse> {
    const body: ShiftLoginInput = { tenantId, username, password };
    return requestJson<ShiftLoginResponse>('/shift/auth/login', {
      method: 'POST',
      body: JSON.stringify(body),
    });
  }

  async me(): Promise<ShiftAuthUser> {
    return requestJson<ShiftAuthUser>('/shift/auth/me', {
      method: 'GET',
    });
  }

  async changePassword(currentPassword: string, newPassword: string, confirmPassword: string): Promise<void> {
    await requestNoContent('/shift/auth/change-password', {
      method: 'POST',
      body: JSON.stringify({ currentPassword, newPassword, confirmPassword }),
    });
  }

  async logout(): Promise<void> {
    await requestNoContent('/shift/auth/logout', {
      method: 'POST',
      body: JSON.stringify({}),
    });
  }
}

export const shiftAuthService = new ShiftAuthService();
